export default {
  // Navbar
  nav: {
    howItWorks: 'So funktioniert’s',
    newUpload: 'Neuer Upload',
    signInSave: 'Anmelden zum Speichern',
    upload: 'Hochladen',
    files: 'Dateien',
    account: 'Konto',
    signOut: 'Abmelden',
    pricing: 'Preise',
    legal: 'Rechtliches',
    goToApp: 'Zur App',
    signInGoogle: 'Mit Google anmelden',
  },

  // Landing
  landing: {
    formatsTitle: 'Öffnet 70 Dateitypen',
    formatsLink: 'Alle Formate ansehen',
    eyebrow: '3D-Viewer für Revit, IFC, STEP und 70 Dateitypen',
    ctaUpload: 'Neuer Upload',
    ctaNoAccount: 'Ohne Registrierung testen',
    viewerCaption: 'IFC-Modell live · ziehen zum Drehen',
    heroTitle1: 'BIM-Dateien teilen.',
    heroTitle2: 'Einfach und schnell.',
    heroSubtitle: 'Öffnen Sie Revit, IFC, STEP, Tekla, Rhino, DXF, OBJ, FBX, STL und viele weitere 3D-Dateien im Browser. Teilen Sie sie per Link oder betten Sie den Viewer in Ihre Website ein.',
    heroFree: 'Kostenlos – 10 Dateien pro Monat',
    footerRights: 'Alle Rechte vorbehalten.',
  },

  // Upload
  upload: {
    bundled: '{count} Dateien in {name} gepackt',
    bundleHint: 'Modell mit Materialien oder Texturen (OBJ + MTL, DAE, 3DS…)? Legen Sie den ganzen Ordner oder ein ZIP ab.',
    guestNotice: 'Gastmodus: bis zu {limit} Dateien. Melden Sie sich an, um sie zu behalten und Links zu teilen.',
    openViewer: 'Viewer öffnen',
    title: 'Dateien hochladen',
    uploadsThisMonth: 'Uploads diesen Monat',
    remaining: 'verbleibend',
    dragDrop: 'Dateien hierher ziehen',
    orClick: 'oder klicken zum Auswählen',
    formats: 'IFC, DWG, PDF, DXF, BCF, GLTF, GLB, OBJ, FBX, DAE, STL, 3MF, PLY, USDZ und alle anderen Dateitypen',
    limitReached: 'Monatslimit erreicht',
    limitReachedDesc: 'Sie haben alle {limit} Uploads für diesen Monat genutzt.',
    upgradePro: 'Upgrade auf Pro →',
    uploading: 'Wird hochgeladen...',
    uploadComplete: 'Upload abgeschlossen!',
    filesUploaded: '{count} Datei(en) erfolgreich hochgeladen.',
    viewMyFiles: 'Meine Dateien',
    uploadMore: 'Weitere hochladen',
    uploadFailed: 'Upload fehlgeschlagen',
    tryAgain: 'Erneut versuchen',
    limitError: 'Monatliches Upload-Limit erreicht. Mit Pro erhalten Sie mehr Uploads.',
    partialUpload: 'Sie können diesen Monat nur noch {max} Datei(en) hochladen. Die ersten {max} werden hochgeladen.',
    fileTooLarge: '„{name}“ überschreitet die maximale Dateigröße von {limit} in Ihrem Tarif. Mit Pro können Sie größere Dateien hochladen.',
  },

  // Files
  files: {
    title: 'Meine Dateien',
    uploadFiles: 'Dateien hochladen',
    loading: 'Dateien werden geladen...',
    noFiles: 'Noch keine Dateien',
    noFilesDesc: 'Laden Sie Ihre erste Datei hoch, um zu beginnen.',
  },

  // Account
  account: {
    title: 'Konto',
    profile: 'Profil',
    userId: 'Benutzer-ID',
    authProvider: 'Anmeldeanbieter',
    subscription: 'Abonnement',
    currentPlan: 'Aktueller Tarif',
    monthlyLimit: 'Monatliches Upload-Limit',
    price: 'Preis',
    free: 'Kostenlos',
    filesPerMonth: '{count} Dateien / Monat',
    unlimited: 'Unbegrenzt',
    freeForever: '0 € / dauerhaft',
    custom: 'Individuell',
    viewPlans: 'Tarife ansehen & upgraden →',
    upgradeToPro: 'Upgrade auf Pro',
    manageSubscription: 'Abo verwalten',
    processing: 'Wird verarbeitet...',
    usageTitle: 'Nutzung in diesem Monat',
    filesUploaded: 'Dateien in diesem Monat hochgeladen',
    unlimitedRemaining: 'Unbegrenzte Uploads verfügbar',
    uploadsRemaining: 'Noch {count} Upload(s) in diesem Monat',
    limitReached: 'Monatslimit erreicht. Wird im nächsten Monat zurückgesetzt.',
    session: 'Sitzung',
    signOutDesc: 'Auf diesem Gerät von Ihrem Konto abmelden.',
    signOut: 'Abmelden',
  },

  // Account: Claude / MCP API keys
  mcp: {
    title: 'Claude (MCP)',
    serverUrl: 'URL des MCP-Servers',
    desc: 'Nutze BimDrop direkt in Claude: Dateien hochladen, auflisten und Freigabelinks erstellen lassen.',
    keyName: 'Name des Schlüssels',
    keyNamePlaceholder: 'Name des Schlüssels, z. B. Claude Code',
    create: 'Schlüssel erstellen',
    newKeyWarning: 'Kopiere diesen Schlüssel jetzt. Er wird nicht noch einmal angezeigt.',
    claudeCode: 'Claude Code',
    otherClients: 'Andere MCP-Clients (JSON-Konfiguration)',
    copy: 'Kopieren',
    copied: 'Kopiert',
    created: 'erstellt am {date}',
    lastUsed: 'zuletzt genutzt {date}',
    neverUsed: 'nie genutzt',
    revoke: 'Schlüssel widerrufen',
    revokeConfirm: '„{name}“ widerrufen? Claude verliert mit diesem Schlüssel den Zugriff.',
    error: 'Etwas ist schiefgelaufen. Bitte erneut versuchen.',
    claudeApps: 'claude.ai und Claude Desktop',
    claudeAppsSteps: 'Öffne Einstellungen → Konnektoren → Benutzerdefinierten Konnektor hinzufügen, füge die URL oben ein und melde dich mit Google an.',
    claudeCodeSteps: 'Führe danach /mcp in Claude Code aus und melde dich mit Google an.',
    connectedApps: 'Verbundene Apps',
    connected: 'verbunden am {date}',
    disconnect: 'Trennen',
    disconnectConfirm: '„{name}“ trennen? Die App verliert den Zugriff auf deine Dateien.',
    apiKeys: 'API-Schlüssel',
    apiKeysDesc: 'Für Skripte und MCP-Clients ohne Anmeldung. Sende den Schlüssel als „Authorization: Bearer …“.',
  },

  // OAuth consent page (Claude connectors)
  oauth: {
    loading: 'Anfrage wird geprüft…',
    invalid: 'Diese Verbindungsanfrage ist ungültig',
    error: 'Etwas ist schiefgelaufen. Bitte erneut versuchen.',
    title: '{app} Zugriff auf dein BimDrop-Konto erlauben?',
    unverified: 'BimDrop hat diese App nicht verifiziert. Fahre nur fort, wenn du ihr vertraust.',
    signInPrompt: 'Melde dich an, um fortzufahren.',
    signedInAs: 'Angemeldet als {email}.',
    switchAccount: 'Anderes Konto verwenden',
    permissionsTitle: 'Die App kann:',
    permUpload: 'Dateien in dein Konto hochladen',
    permList: 'Deine Dateien und ihre Links sehen',
    permShare: 'Freigabelinks erstellen und widerrufen',
    redirectNote: 'Nach der Freigabe kehrst du zu {host} zurück.',
    allow: 'Erlauben',
    deny: 'Abbrechen',
    redirecting: 'Zurück zu {host}…',
  },

  // Viewer
  viewer: {
    loadingModel: '3D-Modell wird geladen…',
    loadError: 'Modell konnte nicht geladen werden',
    back: 'Zurück',
    fitView: 'Ansicht einpassen',
    projection: 'Projektion',
    hideSelected: 'Ausgewähltes Element ausblenden',
    isolateSelected: 'Ausgewähltes Element isolieren',
    showAll: 'Alle Elemente einblenden',
    share: 'Teilen',
    loading: 'Dateidaten werden geladen...',
    processingBtlx: 'BTLx wird verarbeitet...',
    backToFiles: 'Zurück zu den Dateien',
    notPreviewable: 'Für diesen Dateityp ist keine Vorschau verfügbar.',
    btlxProcessing: 'Das 3D-Modell wird erstellt. Bitte warten Sie einen Moment und laden Sie die Seite neu.',
    btlxError: 'Verarbeitung fehlgeschlagen. Das 3D-Modell konnte nicht erstellt werden.',
    btlxQueued: 'Das 3D-Modell steht in der Warteschlange. Bitte schauen Sie in Kürze wieder vorbei.',
    parts: 'Bauteile',
    layers: 'Ebenen',
  },

  // Shared Viewer
  shared: {
    loading: 'Geteiltes Modell wird geladen...',
    linkNotFound: 'Link nicht gefunden',
    linkExpired: 'Dieser Link existiert nicht oder ist abgelaufen.',
    goToBimdrop: 'Zu Bimdrop',
    sharedVia: 'Diese Datei wurde über Bimdrop mit Ihnen geteilt.',
    download: 'Herunterladen',
    tryFree: 'Bimdrop kostenlos testen →',
    hideSelected: 'Auswahl ausblenden',
    isolateSelected: 'Auswahl isolieren',
    showAll: 'Alle einblenden',
  },

  // FileCard
  fileCard: {
    generating3D: '3D-Modell wird erstellt...',
    processingFailed: 'Verarbeitung fehlgeschlagen',
    queued: 'In der Warteschlange',
    downloadTooltip: 'Herunterladen',
    shareTooltip: 'Teilen',
    editTooltip: 'Bearbeiten',
    deleteTooltip: 'Löschen',
    confirmDelete: 'Zum Bestätigen erneut klicken',
    confirm: 'Bestätigen?',
    view2D: '2D-Ansicht',
    view3D: '3D-Ansicht',
    fileName: 'Dateiname',
    description: 'Beschreibung',
    descriptionPlaceholder: 'Beschreibung hinzufügen...',
    save: 'Speichern',
    cancel: 'Abbrechen',
  },

  // Share Modal
  shareModal: {
    shareTitle: '„{name}“ teilen',
    viewer: 'Viewer',
    embed: 'Einbetten',
    shareFile: 'Datei teilen',
    viewerDesc: 'Teilen Sie einen Viewer-Link. Jeder mit diesem Link kann die Datei im Browser ansehen oder herunterladen – ohne Konto.',
    generatingLink: 'Sicherer Link wird erstellt...',
    tryAgain: 'Erneut versuchen',
    copied: 'Kopiert!',
    copy: 'Kopieren',
    recipientsCanView: 'Empfänger können die Datei direkt ansehen oder herunterladen',
    email: 'E-Mail',
    whatsapp: 'WhatsApp',
    embedDesc: 'Fügen Sie diesen Code in das HTML Ihrer Website ein, um einen interaktiven Viewer einzubetten:',
    generatingEmbed: 'Einbettungscode wird erstellt...',
    directLinkDesc: 'Kopieren Sie den direkten Download-Link oder senden Sie ihn per E-Mail / WhatsApp:',
  },

  // Guest (anonymous) sessions
  guest: {
    badge: 'Gast',
    saveTitle: 'Dateien speichern',
    saveDesc: 'Sie nutzen eine Gastsitzung. Melden Sie sich mit Google an, um Ihre Dateien zu behalten und zu teilen.',
    shareLocked: 'Zum Teilen anmelden',
    shareLockedDesc: 'Öffentliche Links und Einbettungen erfordern ein Konto. Ihre hochgeladenen Dateien werden in Ihr Konto übernommen.',
    accountDesc: 'Gastsitzung. Ihre Dateien gehen verloren, wenn Sie die Browserdaten löschen oder sich abmelden.',
  },

  // Theme toggle
  theme: {
    system: 'Design: System',
    light: 'Design: hell',
    dark: 'Design: dunkel',
  },

  // Cookie Banner
  cookies: {
    message: 'Wir verwenden Cookies, um Ihre Nutzung zu verbessern. Mit der Nutzung von Bimdrop akzeptieren Sie unsere',
    cookiePolicy: 'Cookie-Richtlinie',
    accept: 'Akzeptieren',
  },

  // Pricing
  pricing: {
    title: 'Einfache, transparente Preise',
    subtitle: 'Kostenlos starten. Upgraden, wenn Sie mehr brauchen.',
    free: 'Kostenlos',
    pro: 'Pro',
    enterprise: 'Enterprise',
    forever: 'dauerhaft',
    perMonth: '/Monat',
    freeDesc: 'Ideal für den Einstieg',
    proDesc: 'Für Profis und kleine Teams',
    enterpriseDesc: 'Für Unternehmen mit erweiterten Anforderungen',
    getStarted: 'Jetzt starten',
    comingSoon: 'Demnächst',
    upgrade: 'Upgrade auf Pro',
    processing: 'Wird verarbeitet...',
    contactUs: 'Kontakt',
    popular: 'Beliebt',
    // Features
    freeF1: '10 Datei-Uploads pro Monat',
    freeF2: 'Teilen per Link, E-Mail & WhatsApp',
    freeF3: 'Dateien in Websites einbetten',
    freeF4: 'Einfache Dateiverwaltung',
    freeF5: 'Max. 100 MB pro Datei',
    proF1: '150 Datei-Uploads pro Monat',
    proF2: 'Alle Funktionen des kostenlosen Tarifs',
    proF3: 'Max. 1 GB pro Datei',
    proF4: 'Eigenes Branding in Einbettungen',
    proF5: 'Priorisierter Support',
    proF6: 'Statistiken & Download-Tracking',
    entF1: 'Alles aus Pro',
    entF2: 'Unbegrenzte Dateigröße',
    entF3: 'SSO & Teamverwaltung',
    entF4: 'Eigene Domain',
    entF5: 'SLA & persönlicher Support',
    entF6: 'API-Zugang',
    home: 'Startseite',
    legalCookies: 'Rechtliches & Cookies',
  },

  // Legal
  legal: {
    title: 'Rechtliches & Cookie-Richtlinie',
    lastUpdated: 'Zuletzt aktualisiert: März 2026',
  },

  // How it works page
  how: {
    fmtTekla: 'Tekla-Structures-Modelle ab 2020: Modellordner als ZIP hochladen (Beta)',
    fmtFab: 'Fertigungsdateien: Holz (BTLX) und Stahlbauteile (DSTV NC1)',
    exportTitle: 'Aus Ihrer Software exportieren',
    exportNote: 'Menünamen unterscheiden sich je nach Version leicht.',
    exportRevit1: 'Revit-Projekte 2023–2025 öffnen direkt: laden Sie die .rvt hoch (Beta).',
    exportRevit2: 'Für das vollständige Modell oder andere Versionen: Datei → Exportieren → IFC.',
    exportRevit3: 'Wählen Sie IFC4 Reference View oder IFC 2x3 Coordination View 2.0 und laden Sie die .ifc hoch.',
    exportTekla1: 'Modell: Datei → Exportieren → IFC, Exporttyp „Coordination view“, dann die .ifc hochladen.',
    exportTekla2: 'Fertigung: Fertigung → NC-Dateien (DSTV). Laden Sie die .nc1-Dateien oder ein ZIP des Ordners hoch.',
    exportTekla3: 'Jede NC1 öffnet sich als Stahlbauteil mit Profil, Bohrungen und Positionsnummer.',
    fmtRvt: 'Revit-Projekte 2023–2025, im Browser umgewandelt (Beta)',
    fmtCad: 'Volumen-CAD: Baugruppen mit Namen und Farben',
    fmtMore: 'X, OFF, 3DS, PLY, VRML, CityJSON und mehr. DWG und PDF werden zum Download gespeichert.',
    eyebrow: 'So funktioniert’s',
    title: 'Von der Datei zum teilbaren Link in drei Schritten',
    subtitle: 'Legen Sie eine BIM- oder CAD-Datei ab, betrachten Sie sie in 3D im Browser und senden Sie einen Link. Ohne Plug-ins, ohne Installation.',
    s1Title: 'Datei ablegen',
    s1Desc: 'Ziehen Sie eine Datei in den Upload-Bereich oder wählen Sie sie auf Ihrem Computer aus. Testen Sie es ohne Konto.',
    s1P1: 'IFC, DXF, GLB, OBJ, FBX, DAE, STL, 3MF, USDZ, BTLX, DWG, PDF und mehr',
    s1P2: 'Bis 100 MB im Kostenlos-Tarif, 1 GB mit Pro',
    s1P3: 'Keine Registrierung für die ersten Dateien',
    s2Title: 'In 3D ansehen',
    s2Desc: 'Das Modell öffnet sich direkt im Browser. Drehen Sie es, klicken Sie auf ein Bauteil, um seine Eigenschaften zu sehen, blenden Sie Teile aus oder isolieren Sie sie.',
    s2P1: 'IFC-Attribute und Eigenschaftssätze',
    s2P2: 'DXF-Pläne in 2D, GLB, GLTF und STL in 3D',
    s2P3: 'BTLX-Holzbaudaten automatisch in 3D umgewandelt',
    s3Title: 'Link teilen',
    s3Desc: 'Melden Sie sich mit Google an und erhalten Sie einen öffentlichen Link. Jeder kann den Viewer öffnen, ohne Konto.',
    s3P1: 'Link kopieren oder per E-Mail oder WhatsApp senden',
    s3P2: 'Viewer mit einem Code-Snippet in Ihre Website einbetten',
    s3P3: 'Link-Vorschauen zeigen ein Vorschaubild Ihres Modells',
    mockReady: 'Fertig',
    mockSelected: 'Ausgewählt',
    mockSite: 'Ihre Website',
    accountsTitle: 'Mit oder ohne Konto',
    guestTitle: 'Ohne Konto',
    guestDesc: 'Ideal, um Bimdrop mit Ihrer eigenen Datei zu testen.',
    guestF1: '3 Uploads bis je 100 MB',
    guestF2: 'Ansicht in 3D und 2D',
    guestF3: 'Dateien bleiben nur in diesem Browser',
    accountTitle: 'Mit kostenlosem Google-Konto',
    accountDesc: 'Dateien behalten und teilen.',
    accountF1: '10 Uploads pro Monat',
    accountF2: 'Öffentliche Links und Einbettungen',
    accountF3: 'Ihre Dateien auf allen Geräten',
    formatsTitle: 'Unterstützte Formate',
    fmtIfc: '3D-Modell mit Eigenschaften',
    fmtDxf: '2D-Plan, oder 3D, wenn er 3D-Elemente enthält',
    fmtGlb: '3D-Modell, auch SketchUp- und 3D-Druck-Exporte',
    fmtBtlx: 'Holzbearbeitungsdaten, in 3D umgewandelt',
    fmtOther: 'Gespeichert und zum Download geteilt',
    ctaTitle: 'Mit Ihrer eigenen Datei testen',
  },

  // Viewer workspace (toolbar, panels, saved views)
  ws: {
    frame: 'Einheiten und Ausrichtung',
    units: 'Modelleinheiten',
    upAxis: 'Vertikale Achse',
    upY: 'Y nach oben',
    upZ: 'Z nach oben',
    toolSelect: 'Auswählen',
    toolMeasure: 'Messen',
    toolNote: 'Notiz hinzufügen',
    toolClip: 'Schnitt',
    fit: 'Alles anzeigen',
    presets: 'Ansichten',
    presetIso: 'Isometrie',
    presetTop: 'Draufsicht',
    presetFront: 'Vorderansicht',
    presetBack: 'Rückansicht',
    presetLeft: 'Links',
    presetRight: 'Rechts',
    projection: 'Perspektive / orthogonal',
    walk: 'Begehungsmodus',
    walkHint: 'Ziehen zum Umsehen · WASD oder Pfeiltasten zum Gehen · Esc zum Beenden',
    hide: 'Ausblenden',
    isolate: 'Isolieren',
    showAll: 'Alle einblenden',
    color: 'Farbe',
    clearColors: 'Farben entfernen',
    xray: 'Röntgen',
    screenshot: 'Screenshot',
    fullscreen: 'Vollbild',
    exitFullscreen: 'Vollbild beenden',
    clipX: 'Schnitt X',
    clipY: 'Schnitt Y',
    clipZ: 'Schnitt Z',
    clipFace: 'Auf eine Fläche klicken zum Schneiden',
    clipClear: 'Schnitte entfernen',
    panel: 'Panel',
    panelModel: 'Modell',
    panelCategories: 'Kategorien',
    panelLayers: 'Layer',
    panelViews: 'Ansichten',
    panelNotes: 'Notizen',
    panelMeasures: 'Messungen',
    panelProperties: 'Eigenschaften',
    treeLoading: 'Struktur wird geladen…',
    treeEmpty: 'Keine Struktur verfügbar',
    groupsEmpty: 'Nichts anzuzeigen',
    viewsAdd: 'Aktuelle Ansicht speichern',
    viewsNamePlaceholder: 'Name der Ansicht',
    viewsEmpty: 'Speichern Sie Kamerapositionen, um Betrachter des Links zu führen.',
    viewDefaultName: 'Ansicht {n}',
    notesEmpty: 'Mit dem Notiz-Werkzeug heften Sie Kommentare an das Modell.',
    notePlaceholder: 'Notiz schreiben…',
    noteAdd: 'Notiz hinzufügen',
    cancel: 'Abbrechen',
    delete: 'Löschen',
    edit: 'Bearbeiten',
    saveEdit: 'Speichern',
    measuresEmpty: 'Wählen Sie das Messwerkzeug und klicken Sie auf zwei Punkte.',
    measureClear: 'Alle löschen',
    measureHint: 'Zwei Punkte anklicken zum Messen · Esc zum Abbrechen',
    noteHint: 'Auf das Modell klicken, um eine Notiz zu setzen',
    clipHint: 'Auf eine Fläche klicken für einen Schnitt · Pfeile ziehen zum Verschieben',
    selectionEmpty: 'Wählen Sie ein Bauteil, um seine Eigenschaften zu sehen',
    focus: 'Zentrieren',
    save: 'Ansicht speichern',
    saving: 'Wird gespeichert…',
    saved: 'Ansicht gespeichert',
    saveError: 'Ansicht konnte nicht gespeichert werden',
    tooBig: 'Diese Ansicht ist zu groß zum Speichern. Entfernen Sie ausgeblendete Elemente oder Notizen.',
    unsaved: 'Nicht gespeicherte Änderungen',
    resetShared: 'Zurück zur geteilten Ansicht',
    discard: 'Änderungen verwerfen',
    ownerHint: 'Was Sie hier speichern, sehen alle, die den Link öffnen.',
    sharedBadge: 'Geteilte Ansicht',
    shortcuts: 'Tastenkürzel',
    close: 'Schließen',
    noteBy: 'Notiz',
    tour: 'Geführte Ansichten',
  },

  // Revit files (rvt-rs)
  revit: {
    reading: 'Revit-Datei wird gelesen…',
    converting: 'Revit-Modell wird in IFC umgewandelt…',
    localHint: 'Die Umwandlung erfolgt in Ihrem Browser: Die Datei wird nirgendwohin gesendet.',
    unsupportedTitle: 'Diese Revit-Datei kann noch nicht in 3D angezeigt werden',
    unsupportedDesc: 'Revit {version}, {kind}. Die 3D-Ansicht funktioniert für Revit-Projekte 2023, 2024 und 2025.',
    exportHint: 'In Revit: Datei → Exportieren → IFC, dann die IFC-Datei hier hochladen, um das vollständige Modell zu sehen.',
    download: 'Original herunterladen',
    error: 'Diese Revit-Datei konnte nicht gelesen werden',
    betaHint: 'In Ihrem Browser mit rvt-rs aus Revit umgewandelt. Einige Bauteile sind vereinfacht (Türen, Fenster und Möbel können als Quader erscheinen).',
    kind_project: 'Projekt',
    kind_family: 'Familie',
    kind_template: 'Vorlage',
    kind_unknown: 'Datei',
  },

  // SEO
  seo: {
    howTitle: 'So funktioniert’s — BIM-Dateien hochladen, ansehen und teilen',
    howDesc: 'Legen Sie eine Revit-, IFC-, STEP-, DXF- oder eine von 70 anderen 3D-Dateien ab, betrachten Sie sie im Browser und teilen Sie sie per Link oder Einbettung. Bimdrop Schritt für Schritt.',
    landingTitle: 'Revit, IFC, STEP und 3D-Dateien öffnen und per Link teilen',
    landingDesc:
      'Bimdrop öffnet Revit, IFC, STEP, IGES, Rhino, Tekla, DSTV, DXF, OBJ, FBX, glTF, STL und 70 Dateitypen im Browser, ohne Installation. Teilen Sie sie per Link oder betten Sie einen interaktiven 3D-Viewer ein.',
    pricingTitle: 'Preise – Tarife Free, Pro und Enterprise',
    pricingDesc:
      'Einfache, transparente Preise zum Teilen von BIM-Dateien. Starten Sie kostenlos mit 10 Uploads pro Monat. Mit Pro erhalten Sie höhere Limits, größere Dateien und Statistiken.',
    legalTitle: 'Rechtliches & Cookie-Richtlinie',
    legalDesc:
      'Impressum, Nutzungsbedingungen und Cookie-Richtlinie von Bimdrop.',
  },
} as const
